import step from './step'

const cards =
{
    step
};

export default cards ;
